"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcquisitionStateEnum = void 0;
var AcquisitionStateEnum;
(function (AcquisitionStateEnum) {
    AcquisitionStateEnum[AcquisitionStateEnum["Unobtainable"] = 0] = "Unobtainable";
    AcquisitionStateEnum[AcquisitionStateEnum["Taken"] = 1] = "Taken";
    AcquisitionStateEnum[AcquisitionStateEnum["CanBeBought"] = 2] = "CanBeBought";
    AcquisitionStateEnum[AcquisitionStateEnum["CanBeAuctioned"] = 3] = "CanBeAuctioned";
    AcquisitionStateEnum[AcquisitionStateEnum["AuctionInProgress"] = 4] = "AuctionInProgress";
    AcquisitionStateEnum[AcquisitionStateEnum["CanBeSettled"] = 5] = "CanBeSettled";
})(AcquisitionStateEnum = exports.AcquisitionStateEnum || (exports.AcquisitionStateEnum = {}));
/// Imported Objects START ///
/// Imported Objects END ///
/// Imported Queries START ///
/// Imported Queries END ///
//# sourceMappingURL=types.js.map